var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFooterChatText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 44,
    viewBox: "0 0 169 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 1.79086 2.29086 0 4.5 0H165C167.209 0 169 1.79086 169 4V28C169 30.2091 167.209 32 165 32H154.5L147 43.5V32H4.5C2.29086 32 0.5 30.2091 0.5 28L0.5 4Z",
    fill: "url(#paint0_linear_37899_58542)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37899_58542",
    x1: 97,
    y1: -4,
    x2: 97,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5292F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407EDB"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterChatText);
export default __webpack_public_path__ + "static/media/footer_chat_text.2ab7b4fc905b36bf2780ab77e8bb601f.svg";
export { ForwardRef as ReactComponent };